mutation ($input: UpdateLeadPersonalDataInput!) {
  lead: updateLeadPersonalData(input: $input) {
    id
    phone
    formattedPhone: phone(formatted: true)
    firstname
    lastname
  }
}
